<div class="muf-container">
  <div class="muf-header">
    <button mat-icon-button (click)="goBack()"><mat-icon>arrow_back</mat-icon></button>
    <h2>{{ isEdit ? 'Editar Usuário' : 'Novo Usuário' }}</h2>
  </div>

  <div *ngIf="loading" class="muf-loading"><mat-spinner [diameter]="36"></mat-spinner></div>

  <mat-card *ngIf="!loading">
    <mat-card-content>
      <form [formGroup]="form" class="muf-form">
        <div class="muf-row">
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>Nome</mat-label>
            <input matInput formControlName="firstName">
            <mat-error *ngIf="form.get('firstName')?.invalid">Campo obrigatório</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>Sobrenome</mat-label>
            <input matInput formControlName="lastName">
            <mat-error *ngIf="form.get('lastName')?.invalid">Campo obrigatório</mat-error>
          </mat-form-field>
        </div>
        <div class="muf-row">
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>CPF</mat-label>
            <input matInput formControlName="document" mask="000.000.000-00">
            <mat-error *ngIf="form.get('document')?.invalid">Campo obrigatório</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>E-mail (login)</mat-label>
            <input matInput type="email" formControlName="email">
            <mat-error *ngIf="form.get('email')?.invalid">E-mail inválido</mat-error>
          </mat-form-field>
        </div>
        <div class="muf-row">
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>Telefone</mat-label>
            <input matInput formControlName="phone">
            <mat-error *ngIf="form.get('phone')?.invalid">Campo obrigatório</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>Sexo</mat-label>
            <mat-select formControlName="gender">
              <mat-option *ngFor="let g of genderOptions" [value]="g">{{ g }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </form>

      <!-- Seção de permissões -->
      <div class="muf-permissions" *ngIf="myPermissions.length > 0">
        <h3 class="muf-perm-title">Permissões</h3>
        <p class="muf-perm-hint">Selecione as permissões que este usuário terá:</p>
        <div class="muf-perm-grid">
          <mat-checkbox
            *ngFor="let perm of myPermissions"
            [checked]="isSelected(perm.id)"
            (change)="togglePermission(perm.id)">
            {{ perm.text || perm.role }}
          </mat-checkbox>
        </div>
      </div>

      <div class="muf-actions">
        <button mat-stroked-button (click)="goBack()">Cancelar</button>
        <button mat-raised-button color="primary" (click)="save()" [disabled]="saving">
          {{ saving ? 'Salvando...' : 'Salvar' }}
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</div>
